<template>
  <div class="csReport">
    <div class="select">
      <table>
        <tr>
          <td>代理ID：
            <el-input></el-input>
          </td>
          <td>代理名称：
            <el-input></el-input>
          </td>
          <td>联系电话：
            <el-input></el-input>
          </td>
          <td>
            <el-button style="background-color: #FF9000; color: #FFFFFF; margin-left: 30px;" icon="el-icon-search">搜索
            </el-button>
            <el-button type="info" class="el-icon-delete">清空</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="data">
      <el-table
        :data="csList"
        border
        style="width: 100%">
        <el-table-column
          prop="csId"
          label="代理ID"
          align="center">
          <el-button type="text" @click="csDetail = true" style="color: #FF9000">xxxxxx</el-button>
        </el-table-column>
        <el-table-column
          prop="csName"
          label="代理姓名"
          align="center">
        </el-table-column>
        <el-table-column
          prop="reward"
          label="分润比例"
          align="center">
        </el-table-column>
        <el-table-column
          prop="concat"
          label="联系人"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系电话"
          align="center">
        </el-table-column>
        <el-table-column
          prop="manager"
          label="渠道经理"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          align="center">
        </el-table-column>
      </el-table>
      <div class="detail">
        <el-drawer
          :visible.sync="csDetail"
          :with-header="false"
          direction="rtl"
          size="50%">
          <div class="title">
            <div class="titleImg">
              <img :src="titleImg" width="100%" height="100%" alt=""/>
            </div>
            <div class="orderId">
              <span style="font-size: 16px; display: block; margin-top:-15px">代理：xxx</span>
            </div>
            <div class="orderDetail">
              <table>
                <tr style="height: 10px;">
                  <td style="width: 100px;">代理ID</td>
                  <td style="width: 100px;">代理姓名</td>
                  <td style="width: 100px;">联系电话</td>
                </tr>
                <tr style="height: 10px;">
                  <td>xxx</td>
                  <td>xxxxxx</td>
                  <td>xxxxxxxxxxx</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="tag">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="门店列表" name="first">
                <div class="storeList">
                  <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="storeId"
                      label="门店ID"
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="storeName"
                      label="门店名称"
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="region"
                      label="所在地区"
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="address"
                      label="详细地址"
                      align="center">
                    </el-table-column>
                  </el-table>
                </div>
                <div class="block">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage4"
                    :page-size="100"
                    layout="total, prev, pager, next, jumper"
                    :total="400">
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="BD列表" name="second">
                <div class="bdList">
                  <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="bdID"
                      label="BDID"
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="bdName"
                      label="姓名"
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="position"
                      label="职位"
                      align="center">
                    </el-table-column>
                    <el-table-column
                      prop="phone"
                      label="联系方式"
                      align="center">
                    </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-drawer>
      </div>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-size="100"
        layout="total, prev, pager, next, jumper"
        :total="400">
      </el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CsReport',
  data() {
    return {
      titleImg: require('../../../../static/image/powerbankorder/bianji.png'),
      csDetail: false,
      csList: [{}]
    }
  }
}
</script>

<style scoped>
.csReport {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
}

.select {
  width: 70%;
  margin: auto;
}

.data {
  margin-top: 20px;
  width: calc(100% - 30px);
  height: 78%;
}

.select {
  width: 100%;
  height: 8%;
}

.select table tr td {
  font-size: 16px;
  width: 25%;
}

.select table .el-input {
  width: 60%;
}

.detail {
  width: 100%;
  height: 100%;
}

/deep/ :focus {
  outline: none;
}

.title .el-button {
  background-color: red;
  border-radius: 10px;
  float: right;
  margin-top: -25px;
  margin-right: 20px;
}

.orderDetail {
  width: 100%;
  height: 20%;
}

.orderDetail table {
  display: block;
  text-align: left;
  font-size: 16px;
}

.title {
  height: 15%;
  background-color: #FF9000;
}

.titleImg {
  width: 6%;
  height: 50%;
}

.titleImg img {
  display: block;
  float: left;
  margin: 10px 20px 10px;
}

.orderId {
  float: left;
  margin-top: -20px;
  margin-left: -10px;
}

.detail table {
  margin: 10px;
  font-size: 16px;
  text-align: left;
  width: 80%;
}

.detail table tr td {
  width: 30%;
}

.detail table .el-input {
  width: 70%;
}

.orderList {
  width: 100%;
  height: 70%;
}

.storeList {
  width: calc(100% - 30px);
  height: 600px;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/reportmanagement/csreport.vue